import { useState } from "react";
import { useNavigate } from "react-router-dom";

const hotKeywords = ["星际裂痕", "长夜将明", "悬疑", "科幻", "国漫"];

export default function SearchBand() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const go = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  return (
    <section className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-10">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 className="text-xl font-bold text-background-50 md:text-2xl">找到你想看的那部影片</h2>
            <p className="mt-1 text-sm text-primary-200">支持片名、演员、导演与类型关键词模糊搜索</p>
          </div>
          <form
            onSubmit={(event) => {
              event.preventDefault();
              go(keyword);
            }}
            className="flex w-full items-center gap-2 rounded-full bg-background-50 p-1.5 lg:w-[440px]"
          >
            <i className="ri-search-line ml-2 text-lg text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="输入片名 / 演员 / 类型"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-full bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-secondary-400"
            >
              立即搜索
            </button>
          </form>
        </div>

        <div className="mt-5 flex flex-wrap items-center gap-2">
          <span className="text-xs text-primary-300">热门搜索：</span>
          {hotKeywords.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => go(item)}
              className="rounded-full border border-primary-700 px-3 py-1 text-xs text-primary-100 transition-colors hover:border-secondary-500 hover:text-secondary-300"
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}